export default {
    path: '/error',
    name: 'AppError',
    component: () => import('@/views/error/index.vue'),
    meta: {
        title: 'Ошибка',
        forVisitors: true
    }
}